import { logError } from '@ardoq/logging';

const isValidArdoqUrl = (url: string) =>
  Boolean(url.match(/^\/api\/attachment\//));

export const downloadFile = (url: string) => {
  if (!isValidArdoqUrl(url)) {
    logError(new Error('Attempt to download file from out of Ardoq.'));
    return;
  }

  const link = document.createElement('a');
  link.download = '';
  link.href = url;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
